export class ReplacePricingCardCommand {
	id: number;
	amount: number;
}
